import { forwardRef } from "react";

const V = {
  MANDA: { bg: "#00FFA3", emoji: "🟢", label: "MANDA" },
  ESPERA: { bg: "#FFD500", emoji: "🟡", label: "ESPERA" },
  NAO_MANDA: { bg: "#FF3366", emoji: "🔴", label: "NÃO MANDA" },
};

// Card visual (off-screen) para compartilhamento. NÃO expõe a mensagem privada completa.
export const ShareCard = forwardRef(({ result, verdictLabel }, ref) => {
  if (!result) return null;
  const v = V[result.verdict] || V.ESPERA;
  const quote = result.final_verdict || result.comment || "";
  return (
    <div
      ref={ref}
      style={{
        position: "fixed", left: "-9999px", top: 0,
        width: "1080px", height: "1350px",
        background: "#F4F0E6",
        fontFamily: "Outfit, Arial, sans-serif",
        padding: "80px 72px",
        boxSizing: "border-box",
        display: "flex", flexDirection: "column",
      }}
    >
      {/* header */}
      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <img src="/assets/prapsy-icon.png" alt="" style={{ height: "96px", width: "auto" }} crossOrigin="anonymous" />
        <span style={{ fontSize: "72px", fontWeight: 800, letterSpacing: "-2px" }}>
          <span style={{ color: "#16121f" }}>pra</span>
          <span style={{ color: "#FF3366" }}>psy</span>
        </span>
      </div>

      <div style={{ marginTop: "70px" }}>
        <span style={{
          display: "inline-block", background: "#16121f", color: "#fff",
          fontSize: "34px", fontWeight: 800, letterSpacing: "3px",
          padding: "14px 28px", borderRadius: "14px", textTransform: "uppercase",
        }}>
          Prapsy disse
        </span>
      </div>

      {/* quote */}
      <div style={{ flex: 1, display: "flex", alignItems: "center" }}>
        <p style={{
          fontSize: "62px", lineHeight: 1.25, fontWeight: 700, color: "#16121f",
          margin: 0,
        }}>
          “{quote}”
        </p>
      </div>

      {/* verdict pill */}
      <div>
        <span style={{
          display: "inline-block", background: v.bg,
          border: "6px solid #000", borderRadius: "24px",
          fontSize: "48px", fontWeight: 800, padding: "18px 40px",
          boxShadow: "10px 10px 0 #000", textTransform: "uppercase",
        }}>
          {v.emoji} {verdictLabel || v.label}
        </span>
      </div>

      {/* footer */}
      <div style={{ marginTop: "60px", borderTop: "4px solid #000", paddingTop: "36px" }}>
        <p style={{ fontSize: "40px", fontWeight: 700, color: "#16121f", margin: 0 }}>
          Antes de responder, pense duas vezes.
        </p>
        <p style={{ fontSize: "34px", fontWeight: 700, color: "#FF3366", margin: "12px 0 0" }}>
          prapsy
        </p>
      </div>
    </div>
  );
});
